<template>
    <div>
        <!-- Modal -->
        <div class="modal fade" :id="'imageGalleryModal' + sufixo" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Visualização</h5>
                            <button type="button" class="close" @click="fechar_galeria()" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                    </div>
                    <div class="modal-body">
                        <div class="form-row mb-2">
                            <div class="col col-12" :class="( especialidades && especialidades.length > 1 ) || ( tipos && tipos.length > 0 ) ? 'col-md-6' : ''">
                                <az-input  
                                    sizing="sm"
                                    icon="fa-solid fa-magnifying-glass"
                                    placeholder="Pesquisar..."
                                    v-model="pesquisa">
                                    <template v-slot:buttonposb>
                                        <div class="input-group-append">
                                            <span class="input-group-text" id="basic-addon2" title="Arquivos">
                                                {{ lista.length }}
                                            </span>
                                        </div>
                                        <div class="input-group-append" v-if="lista.length">
                                            <button type="button" class="btn btn-outline-primary" @click="ver_conteudo()">
                                                <i class="fa-regular fa-images mr-2"></i>
                                                Ver Conteúdo
                                            </button>
                                            <button type="button" class="btn btn-outline-primary" @click="abrir_na_lateral()">
                                                <i class="fa-solid fa-right-to-line"></i>
                                            </button>
                                        </div>
                                    </template>
                                </az-input>
                            </div>
                            <template v-if="( especialidades && especialidades.length > 1 ) || ( tipos && tipos.length > 0 )">
                                <div class="col col-12 col-md-3">
                                    <az-input
                                        placeholder="Especialidade..."
                                        sizing="sm"
                                        type="select"
                                        :optionsList="especialidades"
                                        optionsData="id_especialidade"
                                        :edicao="( especialidades && especialidades.length > 0 ) ? true : false"
                                        v-model="id_especialidade" />
                                </div>
                                <div class="col col-12 col-md-3">
                                    <az-input
                                        placeholder="Tipo..."
                                        sizing="sm"
                                        type="select"
                                        :optionsList="tipos"
                                        :edicao="( tipos && tipos.length > 0 ) ? true : false"
                                        optionsData="id_tipo_arquivo"
                                        v-model="id_tipo_arquivo" />
                                </div>
                            </template>
                        </div>

                        <az-empty-state v-if="!lista.length" msg="Nenhum arquivo encontrado." />

                        <template v-else>

                            <div v-if="!visao_galeria">

                                <table class="table">
                                    <thead>
                                        <tr>
                                            <th>Atendimento</th>
                                            <th>Data</th>
                                            <th>Arquivo</th>
                                            <th>Tipo</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(arquivo, iax) in lista" :key="iax">
                                            <td>
                                                <a href="#" @click.prevent="abrir_atendimento(arquivo.id_atendimento)" class="card-link">
                                                    #{{ arquivo.id_atendimento }}
                                                </a>
                                            </td>
                                            <td>
                                                {{ $util.getFormatDate(arquivo.dt_ref) }}
                                                <i class="fa-solid fa-lock ml-1" v-if="arquivo.st_tipo_especial == 'locked'"></i>
                                            </td>
                                            <td>
                                                <a :href="arquivo.arquivo.temporary_url" target="_blank" class="card-link">
                                                    {{ arquivo.arquivo.st_titulo }}
                                                </a>
                                            </td>
                                            <td>
                                                {{ arquivo.arquivo.st_tipo_arquivo }}
                                            </td>
                                            <td>
                                                <a v-if="arquivo.arquivo.tipo" href="#" @click.prevent="id_tipo_arquivo == arquivo.arquivo.tipo.id_tipo_arquivo ? id_tipo_arquivo = '' : id_tipo_arquivo = arquivo.arquivo.tipo.id_tipo_arquivo">
                                                    <span v-if="arquivo.arquivo.tipo.st_sigla" class="mr-1">
                                                        {{ arquivo.arquivo.tipo.st_sigla }}: 
                                                    </span>
                                                    {{ arquivo.arquivo.tipo.search }}
                                                </a>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                            </div>

                            <div v-else>

                                <div class="alert alert-primary d-flex justify-content-between">
                                    <div>
                                        {{ sel_images.length }} {{ sel_images.length > 1 ? 'imagens selecionadas' : 'imagem selecionada' }}
                                    </div>
                                    <div>
                                        <button type="button" class="btn btn-sm btn-outline-primary" :disabled="sel_images.length != 2"
                                            @click="comparar()">
                                            Comparar
                                        </button>
                                        <az-submit color="outline-success btn-sm ml-1" v-if="sel_images && sel_images.length && sel_images.length <= 10" @click="compartilhando = !compartilhando">
                                            <i class="fas fa-share mr-2"></i>
                                            Compartilhar
                                        </az-submit>
                                        <button type="button" class="btn btn-sm btn-outline-primary ml-1" @click="toggle_all_groups()" title="Expandir/Retrair Todos">
                                            <i class="fa-solid fa-maximize"></i>
                                        </button>
                                    </div>
                                </div>

                                <div v-if="compartilhando && sel_images.length && sel_images.length <= 10" class="card">
                                    <div class="card-body">
                                        <az-input
                                            icon="fas fa-comment fa-fw" 
                                            v-model="st_obs">
                                        </az-input>
                                        <az-input
                                            icon="far fa-envelope fa-fw" 
                                            type="email"
                                            v-model="st_email">
                                            <template v-slot:buttonposb>
                                                <div class="input-group-append">
                                                    <az-submit color="outline-primary" @click="enviar()">Enviar</az-submit>
                                                </div>
                                            </template>
                                        </az-input>
                                    </div>
                                </div>

                                <viewer :images="arquivos">
                                    <div v-for="(itens, grupo, igx) in agrupar_data(lista)" :key="igx">
                                        <div class="form-row">
                                            <div class="col col-11">
                                                <a href="#" @click.prevent="toggle_grupo(grupo)" class="card-link d-flex flex-column">
                                                    <span class="badge badge-primary mb-1" v-if="grupo != '1900-01-01'">
                                                        {{ $util.getFormatDate(grupo) }}
                                                        / {{ itens.length }}
                                                    </span>
                                                    <span class="badge badge-primary mb-1" v-else>
                                                        {{ itens.length }}
                                                    </span>
                                                </a>
                                            </div>
                                            <div class="col col-1">
                                                <a href="#" @click.prevent="ver_conteudo(itens)" class="card-link d-flex flex-column">
                                                    <span class="badge badge-primary">
                                                        <i class="fa-regular fa-images"></i>
                                                    </span>
                                                </a>
                                            </div>
                                        </div>
                                        <div v-show="!exp_grupos || exp_grupos[grupo]">
                                            <figure class="figure" v-for="(arquivo, iax) in itens" :key="iax" 
                                                style="width: 200px; height: 120px;">
                                                <template v-if="arquivo.arquivo.st_tipo_arquivo == 'pdf'">
                                                    <a :href="arquivo.arquivo.temporary_url" target="_blank" class="card-link">
                                                        <i class="far fa-file-pdf fa-3x mb-1"></i>
                                                    </a>
                                                    <div v-if="arquivo.arquivo.tipo && arquivo.arquivo.tipo.st_sigla" :title="arquivo.arquivo.tipo.search">
                                                        <span class="badge badge-light">
                                                            {{ arquivo.arquivo.tipo.st_sigla }}
                                                        </span>
                                                    </div>
                                                    <div class="text-truncate" :title="arquivo.arquivo.st_titulo">
                                                        {{ arquivo.arquivo.st_titulo }}
                                                    </div>
                                                    <div v-if="anexos && arquivo.id_atendimento">
                                                        <a href="#" @click.prevent="abrir_atendimento(arquivo.id_atendimento)" class="card-link">
                                                            #{{ arquivo.id_atendimento }}
                                                        </a>
                                                    </div>
                                                    <div>
                                                        <span v-if="false">{{ $util.getFormatDate(arquivo.dt_ref) }}</span>
                                                        <i class="fa-solid fa-lock ml-1" v-if="arquivo.st_tipo_especial == 'locked'"></i>
                                                    </div>
                                                </template>
                                                <template v-else-if="arquivo.arquivo.st_tipo_arquivo == 'docx' || arquivo.arquivo.st_tipo_arquivo == 'xlsx' || arquivo.arquivo.st_tipo_arquivo == 'pptx'">
                                                    <a :href="link_office(arquivo.arquivo)" target="_blank" class="card-link">
                                                        <i class="fa-solid fa-file-word fa-3x mb-1" v-if="arquivo.arquivo.st_tipo_arquivo == 'docx'"></i>
                                                        <i class="fa-solid fa-file-excel fa-3x mb-1" v-else-if="arquivo.arquivo.st_tipo_arquivo == 'xlsx'"></i>
                                                        <i class="fa-solid fa-file-powerpoint fa-3x mb-1" v-else-if="arquivo.arquivo.st_tipo_arquivo == 'pptx'"></i>
                                                        <i class="fa-solid fa-file fa-3x mb-1" v-else></i>
                                                    </a>
                                                    <div class="text-truncate" :title="arquivo.arquivo.st_titulo">
                                                        {{ arquivo.arquivo.st_titulo }}
                                                    </div>
                                                    <div v-if="anexos && arquivo.id_atendimento">
                                                        <a href="#" @click.prevent="abrir_atendimento(arquivo.id_atendimento)" class="card-link">
                                                            #{{ arquivo.id_atendimento }}
                                                        </a>
                                                    </div>
                                                    <div>
                                                        <span v-if="false">{{ $util.getFormatDate(arquivo.dt_ref) }}</span>
                                                        <i class="fa-solid fa-lock ml-1" v-if="arquivo.st_tipo_especial == 'locked'"></i>
                                                        <span class="badge badge-light ml-1" v-if="arquivo.arquivo.tipo && arquivo.arquivo.tipo.st_sigla" :title="arquivo.arquivo.tipo.search">
                                                            {{ arquivo.arquivo.tipo.st_sigla }}
                                                        </span>
                                                    </div>
                                                </template>
                                                <template v-else>
                                                    <img :src="arquivo.arquivo.temporary_url" class="figure-img img-fluid rounded" style="max-height: 120px;" loading="lazy">
                                                    <figcaption class="figure-caption">
                                                        <div>
                                                            <input type="checkbox" v-model="arquivo.arquivo.comparar" class="mr-2">
                                                            Selecionar
                                                        </div>
                                                        <div class="text-truncate" :title="arquivo.arquivo.st_titulo">
                                                            {{ arquivo.arquivo.st_titulo }}
                                                        </div>
                                                        <div>
                                                            <span v-if="false">{{ $util.getFormatDate(arquivo.dt_ref) }}</span>
                                                            <i class="fa-solid fa-lock ml-1" v-if="arquivo.st_tipo_especial == 'locked'"></i>
                                                            <span class="badge badge-light ml-1" v-if="arquivo.arquivo.tipo && arquivo.arquivo.tipo.st_sigla" :title="arquivo.arquivo.tipo.search">
                                                                {{ arquivo.arquivo.tipo.st_sigla }}
                                                            </span>
                                                        </div>
                                                    </figcaption>
                                                </template>
                                            </figure>
                                        </div>
                                    </div>
                                </viewer>

                            </div>

                        </template>

                        <pre v-if="false">{{ arquivos }}</pre>
                    </div>
                    <div class="modal-footer">
                        <a href="#" class="card-link mr-3 small" @click.prevent="toggle_visao_galeria()"
                            data-toggle="tooltip" data-placement="top" title="Modelo de visão dos arquivos.">
                            <i class="fa-solid fa-list fa-2x fa-fw" v-if="visao_galeria" title="Mudar para visão em lista."></i>
                            <i class="fa-solid fa-images fa-2x fa-fw" v-else title="Mudar para visão em galeria de imagens."></i>
                        </a>   

                        <a href="#" class="card-link mr-3 small" @click.prevent="ordem_crescente = !ordem_crescente"
                            data-toggle="tooltip" data-placement="top" title="Ordem dos arquivos.">
                            <i class="fas fa-sort-numeric-down fa-2x fa-fw" v-if="ordem_crescente"></i>
                            <i class="fas fa-sort-numeric-down-alt fa-2x fa-fw" v-else></i>
                        </a>   

                        <az-input
                            sizing="sm"
                            type="checkbox-group"
                            label="Imagens" 
                            v-model="filtro.imagens" />
                        <az-input
                            sizing="sm"
                            type="checkbox-group"
                            label="PDF" 
                            v-model="filtro.pdf" />
                    </div>
                </div>
            </div>
        </div>

        <view-anexos-preview ref="preview" />

        <!-- Modal -->
        <div class="modal fade" :id="'compareModal' + sufixo" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="arquivos">
                    <div class="modal-body text-center">
                        <div :style="{ maxWidth: '100%' }" v-if="sel_images.length == 2">
                            <VueCompareImage 
                                :leftImage="sel_images[0].arquivo.temporary_url" 
                                :rightImage="sel_images[1].arquivo.temporary_url"
                                :leftLabel="$util.getFormatDate(sel_images[0].dt_ref)"
                                :rightLabel="$util.getFormatDate(sel_images[1].dt_ref)" />
                        </div>
                    </div>
                    <div class="modal-footer">
                        <template v-if="emmodal">
                            <button type="button" class="btn btn-secondary" @click="fechar()">Fechar</button>    
                        </template>
                        <template v-else>
                            <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                            <button type="button" class="btn btn-primary" @click="voltar()">Voltar</button>
                        </template>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import $ from 'jquery';
import _ from 'lodash';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import VueCompareImage from 'vue-compare-image';
import AzInput from '../../shared/forms/AzInput.vue';
import ViewAnexosPreview from './ViewAnexosPreview.vue';

export default {
    data() { 
        return { 
            abrindo: false, 
            arquivos: null, 
            id_paciente: null, 

            selecionada: null,

            showCompare: false, 

            st_email: "", 
            st_obs: "", 
            compartilhando: false, 

            filtro: { 
                imagens: true,
                pdf: false,
                carregado: false, 
            },

            ordem_crescente: true, 
            visao_galeria: true, 

            anexos: null, 
            pesquisa: "", 
            especialidades: [], 
            tipos: [], 

            id_especialidade: "", 
            id_tipo_arquivo: "", 

            exp_grupos: null, 
        }
    },

    computed: { 
        sufixo: function () { 
            return ( this.emmodal ? 'M' : '' );
        },

        lista: function () { 
            if ( !this.arquivos )
                return [];

            let reg = this.$util.getregex(this.pesquisa);

            return _.orderBy(
                this.arquivos.filter(item => !this.pesquisa || reg.test(JSON.stringify(item)))
                    .filter(item => !this.id_especialidade || ( item.especialidade && item.especialidade.id_especialidade == this.id_especialidade ))
                    .filter(item => !this.id_tipo_arquivo || ( item.arquivo.id_tipo_arquivo == this.id_tipo_arquivo ))
                    .filter(item => 
                        ( item.arquivo.st_tipo_arquivo != 'pdf' && this.filtro.imagens ) 
                        || ( item.arquivo.st_tipo_arquivo == 'pdf' && this.filtro.pdf )  ),
                'dt_ref',
                ( this.ordem_crescente ? 'asc' : 'desc' )
            );
        },

        images: function () { 
            if ( !this.arquivos )
                return [];

            return this.arquivos.map(item => item.arquivo.temporary_url);
        },

        sel_images: function() { 
            if ( !this.arquivos )
                return [];

            return this.arquivos.filter(item => item.arquivo.comparar);
        },

        selecionadas: function () { 
            if ( !this.arquivos )
                return 0;

            return this.arquivos.filter(item => item.arquivo.visibility).length;
        }
    },

    components: { 
        AzEmptyState,
        VueCompareImage,
        AzSubmit, 
        AzInput,
        ViewAnexosPreview
    },

    props: ['emmodal'],

    watch: { 
        filtro: { 
            handler: function () {
                if ( this.filtro.carregado ) { 
                    this.$util.setCookie('g-img', this.filtro.imagens ? 'S' : 'N');
                    this.$util.setCookie('g-pdf', this.filtro.pdf ? 'S' : 'N'); 
                }
            },
            deep: true,
            immediate: true
        },

        ordem_crescente: function (newValue) { 
            let atual = this.$util.getCookie('gal-ord');

            if ( newValue && ( !atual || atual == 'C' ) ) { 
                return;
            }

            this.$util.setCookie(
                'gal-ord', 
                newValue ? 'C' : 'D', 
                newValue ? 1 : 1000
            );
        },
    },

    methods: { 
        toggle_all_groups () { 
            let teste; 
            
            _.each(this.exp_grupos, item => { 
                if ( !item ) { 
                    teste = true;
                }
            });

            console.log('teste', teste);

            this.exp_grupos = _.mapValues(this.exp_grupos, () => teste ? true : false);
        },

        toggle_grupo (grupo) { 
            this.$set(this.exp_grupos, grupo, !this.exp_grupos[grupo]);
        },

        agrupar_data(lista) { 
            return _.groupBy(lista, item => item.dt_ref ? item.dt_ref.slice(0, 10) : '?');
        },

        toggle_visao_galeria() { 
            this.visao_galeria = !this.visao_galeria;
            $('[data-toggle="tooltip"]').tooltip("dispose");
        },

        link_office(arquivo) { 
            return "https://view.officeapps.live.com/op/view.aspx?src=" 
                + encodeURIComponent(arquivo.temporary_url)
                + '&wdEmbedCode=0&wdPrint=0';
        },

        ver_conteudo (lista = null) { 
            this.$refs.preview.abrir(lista ? lista : this.lista);
        },

        abrir_na_lateral (lista = null) { 
            this.$refs.preview.abrir(lista ? lista : this.lista, true);
        },

        abrir_atendimento (id_atendimento) { 
            $('.modal').modal('hide');

            if ( this.$route.path == '/recepcao' ) { 
                this.$router.push({ name: "dashboard" });
            }

            this.$nextTick(() => { 
                this.$util.abrir_atendimento(this, id_atendimento);
            });
        },

        enviar() { 
            this.$util.atualizar(this, { 
                service: 'mensagens', 
                func: 'enviar_anexos',
                dados: { 
                    texto: this.st_obs,
                    destino: this.st_email, 
                    anexos: this.sel_images,  
                },
                callback: () => { 
                    this.$toast.add({
                        severity: "success",
                        summary: "Atenção",
                        detail: "Messagem enviada.",
                        life: 3000
                    });

                    this.compartilhando = false;
                }
            });
        },

        compartilhar () { 
            this.compartilhando = true;
        },

        refresh() { 
            this.arquivos = null;
        },

        fechar_galeria() { 
            $('#imageGalleryModal' + this.sufixo).modal('hide');
        },

        fechar() { 
            $('#compareModal' + this.sufixo).modal('hide');
        },

        voltar() {
            $('#imageGalleryModal' + this.sufixo).modal('show');
        },

        comparar() { 
            if ( this.sel_images.length == 2 ) { 
                if ( !this.emmodal ) 
                    $('.modal').modal('hide');
            
                $('#compareModal' + this.sufixo).modal('show');
            }
        },

        abrir(atendimento, refresh = false) { 

            let anexos = atendimento.anexos ? true : false;

            if ( refresh || this.id_paciente != atendimento.id_paciente || anexos != this.anexos )
                this.arquivos = null;

            this.st_email = _.get(atendimento, 'paciente.cadastro.st_email');

            this.compartilhando = false;
            this.st_obs = "";
            this.pesquisa = "";
            this.anexos = anexos;
            
            this.abrindo = true;
            $('#imageGalleryModal' + this.sufixo).modal('show');

            if ( !this.arquivos ) { 

                this.especialidades = [];

                this.$store.commit('loading', true);

                this.$util.loadItem(this, { 
                    service: 'pacientes',
                    func: 'arquivos',
                    parms: { 
                        id_paciente: atendimento.id_paciente,
                        anexos: atendimento.anexos ? true : false, 
                    }
                })
                .then(res => { 
                    this.id_paciente = atendimento.id_paciente;

                    let exp_grupos = {};
                    let primeiro = "";
                    
                    res.map(item => ( item && item.dt_ref ) ? item.dt_ref.slice(0, 10) : '?')
                        .forEach((item) => { 

                            if ( item > primeiro ) { 
                                primeiro = item;
                            }

                            exp_grupos[item] = false;

                        });

                    if ( primeiro ) { 
                        exp_grupos[primeiro] = true;
                    }

                    this.exp_grupos = exp_grupos;
                    
                    this.arquivos = res.map(item => { 
                        item.comparar = false;
                        return item;
                    });

                    this.especialidades = _.orderBy(
                        _.uniqBy(res.filter(item => item.especialidade).map(item => item.especialidade), 'id_especialidade'),
                        'st_especialidade'
                    );

                    if ( this.id_especialidade && !this.especialidades.find(item => item.id_especialidade == this.id_especialidade) ) { 
                        this.id_especialidade = "";
                    }

                    this.tipos = _.orderBy(
                        _.uniqBy(res.filter(item => item.arquivo && item.arquivo.tipo).map(item => item.arquivo.tipo), 'id_tipo_arquivo'),
                        'search'
                    );

                    if ( this.id_tipo_arquivo && !this.tipos.find(item => item.id_tipo_arquivo == this.id_tipo_arquivo) ) { 
                        this.id_tipo_arquivo = "";
                    }
                })
                .finally(() => { 
                    this.$store.commit('loading', false);
                });

            }

        }

    },

    beforeMount() { 
        this.filtro.imagens = this.$util.getCookie('g-img') == 'N' ? false : true; 
        this.filtro.pdf = this.$util.getCookie('g-pdf') == 'S' ? true : false; 
        this.filtro.carregado = true;

        this.ordem_crescente = ( this.$util.getCookie('gal-ord') == 'D' ? false : true );
    }

}
</script>

<style scoped>

.thumb {
    background-color: #CCC;
    background-position: center center;
    background-repeat: no-repeat;
    border: 1px solid #000;
    margin: 5px;
    width: 100px;
    height: 100px;
}

.contain {
    background-size: contain;
    -moz-background-size: contain;
}
.cover {
    background-size: cover;
    -moz-background-size: cover;
}


</style>